import type { ElementType, HTMLAttributes, ReactNode, Ref } from "react"

import { gapScale } from "@/components/ui/layout"
import { tv, type VariantProps } from "@/lib/utils/tv"

const reel = tv({
  base: "reel",
  variants: {
    gap: gapScale,
    snap: { true: "snap-x snap-mandatory", proximity: "snap-x snap-proximity" },
    inset: { true: "px-gut scroll-px-gut" },
  },
  defaultVariants: { gap: "300" },
})

interface ReelProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof reel> {
  ref?: Ref<HTMLElement>
  as?: ElementType
  children?: ReactNode
}

export const Reel = ({ gap, snap, inset, as, className, children, ...rest }: ReelProps) => {
  const Element = as ?? "div"
  return (
    <Element className={reel({ gap, snap, inset, className })} {...rest}>
      {children}
    </Element>
  )
}
